<template>
  <component
    :is="href ? 'a' : 'div'"
    :aria-label="label"
    class="bg-gray-100 text-gray-600 w-fit items-center whitespace-nowrap rounded-lg p-1 px-1.5 text-xs flex gap-x-1 shadow-md font-medium ring-1 ring-gray-400"
    :class="{ 'hover:text-orange cursor-pointer': !!href }"
    :href="href"
    :rel="href ? 'noopener noreferrer' : undefined"
    :target="href ? '_blank' : undefined"
    @click="href && onLinkClick($event)"
  >
    <div>
      <slot name="icon" />
    </div>
    <span class="truncate">
      <slot />
    </span>
  </component>
</template>

<script setup lang="ts">
const props = defineProps<{
  label: string
  href?: string
}>()

function onLinkClick(event: MouseEvent): void {
  event.stopPropagation()
  event.preventDefault()
  window.open(props.href!, '_blank', 'noopener,noreferrer')
}
</script>
